import React from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";

import "./BasicBanner.css";

const BasicBanner = ({
  backgroundImage,
  mainImage,
  title,
  subtitle,
  description,
  buttons,
  ...props
}) => {
  return (
    <div
      className="basic-banner"
      style={{
        backgroundImage: `url("${backgroundImage?.img}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      {description || subtitle || buttons ? (
        <div className="banner-left-side">
          <div className="title-container-banner">
            <h1>{title && Parser(title)}</h1>
            {subtitle && <h2>{subtitle}</h2>}
          </div>
          {description && (
            <div className="description-banner">{Parser(description)}</div>
          )}
          {buttons && buttons.length > 0 && (
            <div className="btn-group">
              {buttons.map((button, index) => (
                <a
                  key={index}
                  href={button.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="btn-banner">
                    <img src={button.img} alt={button.alt}></img>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="title-container-banner">
          <h1>{title && Parser(title)}</h1>
        </div>
      )}
      {mainImage && mainImage.img && (
        <div className="main-image-container">
          <img src={mainImage?.img} alt={mainImage?.alt} />
        </div>
      )}
    </div>
  );
};

BasicBanner.propTypes = {
  backgroundImage: PropTypes.object,
  mainImage: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  buttons: PropTypes.array,
};

export default BasicBanner;
